import { v4 as uuidv4 } from 'uuid';

import { defaultBoardOptions } from '../global/constants';
import {
  ArtboardOptions,
  DesignState,
  DesignStateMultiBoard,
  DesignStateSoleBoard,
  SerializedBoard,
  TextureOptions,
  isSerializedFloatingBoard,
} from '../types';

export const getArtboardOptions = (
  data:
    | Pick<DesignStateMultiBoard, 'boards'>
    | Pick<DesignStateSoleBoard, 'artboardOptions'>
): Omit<ArtboardOptions, 'canvas'> => {
  if ('boards' in data && data.boards.length) {
    const board = data.boards[0];
    if (!isSerializedFloatingBoard(board)) {
      return board.artboard;
    }
  }

  if ('artboardOptions' in data) {
    return data.artboardOptions;
  }

  return { ...defaultBoardOptions };
};

export const getTextureOptions = (
  data:
    | Pick<DesignStateMultiBoard, 'boards'>
    | Pick<DesignStateSoleBoard, 'overlayOptions'>
): TextureOptions | null => {
  if ('boards' in data) {
    const board = data.boards[0];
    if (!isSerializedFloatingBoard(board)) {
      return board.texture ?? null;
    }
  }

  if ('overlayOptions' in data) {
    return data.overlayOptions ?? null;
  }

  return null;
};

export const getSerializedBoardsFromState = (
  state: DesignState,
  templateId?: string
): SerializedBoard[] => {
  if ('boards' in state) {
    return templateId
      ? state.boards.map((board) => ({
          ...board,
          originTemplateId: templateId,
        }))
      : state.boards;
  } else {
    const { backgroundImage, ...artboard } = state.artboardOptions;
    const boardId = uuidv4()!;
    const soleBoard: SerializedBoard = {
      id: boardId,
      artboard,
      objects: state.objects ?? [],
      groupStructure: state.groupStructure ?? { children: [] },
      originTemplateId: templateId,
    };
    soleBoard.groupStructure.meta = {
      ...(soleBoard.groupStructure.meta ?? {}),
      linkedBoardId: boardId,
    };
    if (backgroundImage) {
      soleBoard.backgroundImage = backgroundImage;
    }
    if (state.overlayOptions) {
      soleBoard.texture = state.overlayOptions;
    }
    return [soleBoard];
  }
};
